import { render, staticRenderFns } from "./TablePromotion.vue?vue&type=template&id=7fe6c166"
import script from "./TablePromotion.vue?vue&type=script&lang=js"
export * from "./TablePromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports